<template>
<div>
  <div class="popBg" @click="close"></div>

  <div class="popup fixed"  v-if="statusCode === 0 || statusCode === 1">
    <div class="popup__inner fixed z-40 py-5 px-4 md:px-8 bg-white max-w-sm md:max-w-md rounded flex flex-col items-center">
      <div class="popup__header text-NotoSansRegular textColorRed text-base mb-3 md:mb-5 flex justify-center flex-col md:flex-row items-center">
        <span>系統已發送驗證碼</span>
        <span class="hidden md:block">，</span>
        <span>請前往信箱查看</span>
      </div>
      <div class="popup__body text-NotoSansRegular text-base md:mb-4 px-2 w-2/3 md:w-full">
        <div class="md:flex items-center justify-center">
          <label class="md:w-1/2 block mb-1 md:mb-0 text-NotoSansRegular text-sm whitespace-no-wrap" for="Captcha">
            請輸入六位數驗證碼：
          </label>
            <input class="text-sm appearance-none border-2 rounded py-2 px-4 leading-tight focus:outline-none w-full"
              id="Captcha" type="text" value="" v-model.trim="inputCode" maxlength="6" v-on:keyup.13="submit"
              :disabled="isCodeVerify === true" placeholder="">
        </div>
        <div class="flex justify-end">
          <span class="text-xs textColorRed opacity-0" :class="{ showError: isCodeVerify === false }">驗證碼錯誤</span>
        </div>
      </div>
      <div class="popup__buttons flex justify-center px-2 w-2/3 md:w-full">
        <a class="px-6 py-2 w-full md:w-auto textColorDarkBlack btn btn--small popup__ok cursor-pointer hover:text-white text-NotoSansRegular"
          @click.prevent="submit">
          送出
        </a>
      </div>
      <div class="text-sm mt-5 border-t pt-3">
        <ul class="list-disc list-inside">
          <!-- <li>使用hotmail有可能收不到驗證信，建議使用gmail信箱</li>
          <li>一直沒收到驗證信，有可能跑到垃圾信件或被擋信了喔!</li> -->
          <li>若超過15分鐘尚未收到驗證信，請來電客服為您處理：TEL: 02-2578-7838</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="popup fixed" v-if="statusCode === 2">
    <div class="popup__inner fixed z-40 py-8 px-0 md:px-10 bg-white max-w-xs md:max-w-md rounded">
      <div class="popup__header text-NotoSansRegular textColorRed text-base mb-3 flex justify-center">
        <span>此Email已註冊過囉!</span>
      </div>
      <div class="popup__body text-NotoSansRegular text-base mb-4">
        <p class="mb-5 whitespace-pre-wrap text-center">請使用原帳號登入或更新Email</p>
      </div>
      <div class="popup__buttons flex justify-center">
        <a class="mr-1 px-3 py-2 textColorDarkBlack btn btn--small popup__ok cursor-pointer hover:text-white text-NotoSansRegular"
          @click.prevent="close">
          關閉
        </a>
        <router-link :to="{ name: 'login' }" class="ml-1 px-3 py-2 textColorDarkBlack btn btn--small popup__ok cursor-pointer hover:text-white text-NotoSansRegular">
          登入
        </router-link>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'CaptchaPop',

  data () {
    return {
      inputCode: '',
      isCodeVerify: null
    }
  },

  props: {
    email: {
      type: String
    },
    verifyStatus: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'authorized'
    ]),
    statusCode () {
      let self = this
      if (self.verifyStatus.result && self.verifyStatus.message === 'verification code sent.') {
        // 已傳送驗證碼
        return 0
      } if (!self.verifyStatus.result && self.verifyStatus.message === 'Verification code not expired.') {
        // 驗證碼未過期，等待輸入中
        return 1
      } else {
        // 已經註冊過
        return 2
      }
    }
  },
  watch: {
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    close () {
      let self = this
      self.$emit('closeEmailPop', false)
      self.isCodeVerify = null
    },
    async submit () {
      let self = this
      if (!self.authorized && self.inputCode && self.inputCode.length === 6) {
        // 未登入
        let postData = {
          account: self.email,
          code: self.inputCode
        }
        axios.post('/account/verify', postData)
          .then((response) => {
            self.$emit('closeEmailPop', false)
            self.$emit('isCodeVerify', true)
          })
          .catch(() => {
            self.$emit('isCodeVerify', false)
            self.isCodeVerify = false
            self.inputCode = ''
          })
      } else if (self.authorized && self.inputCode && self.inputCode.length === 6) {
        // 已登入
        let postData = {
          code: self.inputCode
        }
        axios.post('/user/verify/mail', postData)
          .then((response) => {
            self.$emit('closeEmailPop', false)
            self.$emit('isCodeVerify', true)
          })
          .catch(() => {
            self.$emit('isCodeVerify', false)
            self.isCodeVerify = false
            self.inputCode = ''
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup {
  z-index: 1000;
  .popup__inner {
    top: 45%;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transform: scale(0.3);
    -moz-transform: scale(0.3);
    -ms-transform: scale(0.3);
    -o-transform: scale(0.3);
    transform: scale(0.3);

    -webkit-animation-name: example;
    -webkit-animation-duration: .3s;
    animation-name: example;
    animation-duration: .3s;
    animation-fill-mode: forwards;
    .popup__header {
      margin-bottom: 15px;
      font-size: 0.85em;
      font-weight: bold;
    }
    .popup__body {
      font-size: 0.85em;
    }
    .popup__buttons {
          text-align: right;
      .btn--small {
          line-height: 22px;
      }
      .btn {
        display: inline-block;
        font-size: 11px;
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        height: auto;
        line-height: 1;
        background-color: white;
        border: 1px solid #9c9c9c;
        color: #434343;
        white-space: nowrap;
        transition: .3s;
        border-radius: 5px;
        &:hover {
          border: 1px solid #a0a0a0;
          background: #9c9c9c !important;
          color: white;
        }
      }
    }
  }
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}
</style>
